export default {
    "created": "Canalul a fost creat cu succes",
    "updated": "Canalul a fost actualizat cu succes",
    "deleted": "Canalul a fost șters cu succes",
    "restored": "Canalul a fost restaurat cu succes",
}
